import { render, staticRenderFns } from "./appDrawer.vue?vue&type=template&id=230513b7"
import script from "./appDrawer.vue?vue&type=script&lang=js"
export * from "./appDrawer.vue?vue&type=script&lang=js"
import style0 from "./appDrawer.vue?vue&type=style&index=0&id=230513b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports